import { memo } from 'react';
// import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useDeepLink from '../../../../hooks/useDeeplink';
// import { TranslationLocale } from '../../../../i18n';

import { StaminaType } from '../../../../constants/currencies';
import { usePopup } from '../../../../context';
import { NotEnoughTokenStaminaPopup } from '../../../Popups';

import './WEAHomeTemplate.css';

export const WEAHomeTemplate = memo(() => {
  // const { i18n } = useTranslation();
  const showLink = process.env.NODE_ENV === 'development';

  // const onClick = useCallback(
  //   (locale: string) => {
  //     i18n.changeLanguage(locale).catch(console.error);
  //   },
  //   [i18n],
  // );

  const handleOpenApp = useDeepLink(
    `joyajoyapp://user-invite?invitationLinkId=${'02f1417d-907e-4866-85e6-3127d5fb816e'}`,
  );

  const { showPopup, hidePopup } = usePopup();

  return (
    <div className="WEAhome">
      {showLink && (
        <button
          onClick={() =>
            showPopup(
              <NotEnoughTokenStaminaPopup
                nextRefillAt={new Date(1731544246116)}
                onPrimary={hidePopup}
                currencyType={StaminaType.GameStamina}
              />,
            )
          }
        >
          Show Custom Popup
        </button>
      )}
      {showLink && (
        <div className="centered-container">
          <p>The follow link can be easily for UI and debug.</p>
          <nav>
            <div>
              <p className="font-bold text-xl">Deeplink</p>
              <div className="link-group">
                <button onClick={handleOpenApp}>
                  Open in JOYAJOY APP(hook)
                </button>
              </div>
            </div>
            <div>
              <p className="font-bold text-xl">AuthRoute</p>
              <div className="link-group">
                {/* <Link to="/wea-member/">Home</Link> */}
                <Link to="/wea-member/login">Login</Link>
                <Link to="/wea-member/verify">EmailVerification</Link>
                <Link to="/wea-member/reset-password">ResetPassword</Link>
                {/* <Link to="/wea-member/credit-payment">CreditPayment</Link> */}
                <Link to="/wea-member/tts-enhancement">TTSEnhancement</Link>
                <Link to="/wea-member/start">Entry</Link>
                <Link to="/wea-member/register">Register</Link>
                <Link to="/wea-member/register/success">SuccessRegister</Link>
              </div>
            </div>
            {/* <div>
              <p className="font-bold text-xl">NameCardRoute</p>
              <div className="link-group">
                <Link to="/wea-member/name-card/:id/link">NameCardLinkScreen</Link>
                <Link to="/wea-member/name-card/:id/collect">CollectNameCardScreen</Link>
                <Link to="/wea-member/name-card/transfer/:id/link">
                  TransferNameCardLinkScreen
                </Link>
                <Link to="/wea-member/name-card/transfer/:id/transferral">
                  OwnershipTransferralScreen
                </Link>
              </div>
            </div> */}

            {/* <div>
              <p className="font-bold text-xl">ReferralRoute</p>
              <div className="link-group">
                <Link to="/wea-member/referral/:id/join">ReferralJoinScreen</Link>
                <Link to="/wea-member/referral/:id/link">ReferralLinkScreen</Link>
              </div>
            </div> */}
            {/* <div>
              <p className="font-bold text-xl">ClubInvitationRoute</p>
              <div className="link-group">
                <Link to="/wea-member/club-invite/list">ClubInvitationListScreen</Link>
                <Link to="/wea-member/club-invite/create">ClubInvitationScreen</Link>
                <Link to="/wea-member/club-invite/:id/edit">EditClubInvitationScreen</Link>
                <Link to="/wea-member/club-invite/:id/reconfirm">
                  ReconfirmClubInvitationScreen
                </Link>
                <Link to="/wea-member/club-invite/:id/join">JoinClubScreen</Link>
                <Link to="/wea-member/club-invite/:id/success">SuccessJoinClubScreen</Link>
              </div>
            </div> */}
            {/* <div>
              <p className="font-bold text-xl">ReservedNameRoute</p>
              <div className="link-group">
                <Link to="/wea-member/reserved-name/list">ReservedNameListScreen</Link>
                <Link to="/wea-member/reserved-name/create">ReservedNameScreen</Link>
                <Link to="/wea-member/reserved-name/:id/edit">EditReservedNameScreen</Link>
                <Link to="/wea-member/reserved-name/:id/reconfirm">
                  ReconfirmReservedNameScreen
                </Link>
                <Link to="/wea-member/reserved-name/:id/claim">
                  ClaimReservedNameScreen
                </Link>
                <Link to="/wea-member/reserved-name/:id/success">
                  SuccessClaimNameScreen
                </Link>
              </div>
            </div> */}
            {/* <div>
              <p className="font-bold text-xl">ClubRedeemRoute</p>
              <div className="link-group">
                <Link to="/wea-member/club-redeem/:id">Select Category</Link>
                <Link to="/wea-member/club-redeem/:store/category/:id">
                  Select Reward Offer
                </Link>
                <Link to="/wea-member/club-redeem/:store/rewardOffer/:id">
                  Reward Offer
                </Link>
                <Link to="/wea-member/club-redeem/:store/rewardOffer/:id/variants">
                  Reward Offer Variants
                </Link>
                <Link
                  to="/club-redeem/:store/rewardOffer/:id/payment"
                  state={{ variant: { bibleVersion: 'NIV' } }}
                >
                  Reward Offer Payment
                </Link>
                <Link to="/wea-member/club-redeem/:store/rewardRedemption/:id?success=true">
                  Reward Redemption
                </Link>
              </div>
            </div> */}
            {/* <div>
              <p className="font-bold text-xl">ClubMembershipTier</p>
              <div className="link-group">
                <Link to="/wea-member/club-membership-tier/tickets">Ticket List</Link>
              </div>
            </div> */}
            {/* <div>
              <p className="font-bold text-xl">CreateGameRoute</p>
              <div className="link-group">
                <Link to="/wea-member/create-game/help-create">HelpCreate</Link>
              </div>
            </div> */}
            <div>
              <p className="font-bold text-xl">AccountRoute</p>
              <div className="link-group">
                <Link to="/wea-member/account">AccountInfo</Link>
                <Link to="/wea-member/account/display-name">Display Name</Link>
                <Link to="/wea-member/account/username">Username</Link>
                <Link to="/wea-member/account/email">Email</Link>
                <Link to="/wea-member/account/password">Password</Link>
                <Link to="/wea-member/account/region">Region</Link>
              </div>
            </div>
            <div>
              <p className="font-bold text-xl">Posts</p>
              <div className="link-group">
                <Link to="/wea-member/posts/:id">Post</Link>
              </div>
            </div>
            <div>
              <p className="font-bold text-xl">Share</p>
              <div className="link-group">
                <Link to="/wea-member/share?id=f7936ca5-ea1b-4fbb-8c37-659a2c200fdb">
                  Share?id=`InvitationLinkId`
                </Link>
                <Link to="/wea-member/promotion?code=SUMMER2024">
                  promotion?code=`CODE`
                </Link>
              </div>
            </div>
            <div>
              <p className="font-bold text-xl">Debug</p>
              <div className="link-group">
                <Link to="/wea-member/debug">debug</Link>
              </div>
            </div>
            <div>
              <p className="font-bold text-xl">Game</p>
              <div className="link-group">
                <Link to="/wea-member/club/ab554c74-8df7-4c7a-9d8c-4708feeeb8b5/journey/20b511e9-bdc3-4408-8098-d82f8b5bfdf3/game/92d2304a-408b-41b4-ad3e-5edd5bf44170?mode=normal">
                  Quick Memory JOY
                </Link>
                <Link to="/wea-member/club/ab554c74-8df7-4c7a-9d8c-4708feeeb8b5/journey/c3ccd24b-ea12-47aa-b55a-282043662202/game/b3179c0f-8565-4fa0-9f11-38e87fecdd58?mode=normal">
                  Spelling JOY · By Syllables
                </Link>
                <Link to="/wea-member/club/ab554c74-8df7-4c7a-9d8c-4708feeeb8b5/journey/c3ccd24b-ea12-47aa-b55a-282043662202/game/ec865916-bd93-439c-bf3c-7821d4bd55b9?mode=normal">
                  Spelling JOY · By Characters
                </Link>
                <Link to="/wea-member/club/{classroomId}/journey/{gameSetId}/game/{gameId}?mode=tutorial">
                  Gamified Tutorial
                </Link>
                <Link to="/wea-member/club/{classroomId}/journey/{gameSetId}/challenge/{index}">
                  Mini challenge
                </Link>
                <Link to="/wea-member/club/{classroomId}/journey/{gameSetId}/challenge/super">
                  Super challenge
                </Link>
              </div>
            </div>
          </nav>

          {/* <div className="lang-container">
            <button onClick={() => onClick(TranslationLocale.EN)}>EN</button>
            <button onClick={() => onClick(TranslationLocale.HK)}>ZH</button>
            <button onClick={() => onClick(TranslationLocale.TW)}>ZH-TW</button>
            <button onClick={() => onClick(TranslationLocale.CN)}>ZH-CN</button>
            <button onClick={() => onClick(TranslationLocale.JP)}>JA</button>
          </div> */}
        </div>
      )}
    </div>
  );
});
